import { useEffect } from "react";

const CASINO_STYLE_ID = "casino-page-styles";
let mountedCasinoPages = 0;

// Loads the user-provided casino stylesheet only while a casino route is open.
// Future casino pages should call this hook at the top of their component.
export function useCasinoStyles() {
  useEffect(() => {
    mountedCasinoPages += 1;

    let stylesheet = document.getElementById(CASINO_STYLE_ID);
    if (!stylesheet) {
      stylesheet = document.createElement("link");
      stylesheet.id = CASINO_STYLE_ID;
      stylesheet.rel = "stylesheet";
      stylesheet.href = `${process.env.PUBLIC_URL}/casino.css`;
      document.head.appendChild(stylesheet);
    }

    return () => {
      mountedCasinoPages -= 1;
      if (mountedCasinoPages === 0) {
        document.getElementById(CASINO_STYLE_ID)?.remove();
      }
    };
  }, []);
}
